<template>
    <div v-if="havePages" class="pagination-area">
        <ul class="pagination pagination--blue hidden__xs">
            <template v-if="firstResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link pagination__link--disabled">«</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><button class="pagination__link btn--fake-link" rel="prev" @click="emitPageChange(currentPage - 1)">«</button></li>
            </template>
            <template v-for="link in links">
                <li class="pagination__li" :key="link.i" v-if="link.current"><span class="pagination__link" :class="{'pagination__link--active': true, }">{{ link.label }}</span></li>
                <li class="pagination__li pagination__li--disabled" :key="link.i" v-else-if="link.label == '...'"><span class="pagination__link">...</span></li>
                <li class="pagination__li" :key="link.i" v-else><button @click="emitPageChange(link.i)" class="pagination__link btn--fake-link">{{ link.label }}</button></li>
            </template>
            <template v-if="lastResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">»</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><button class="pagination__link btn--fake-link" rel="next" @click="emitPageChange(currentPage + 1)">»</button></li>
            </template>
        </ul>
        <ul class="pagination pagination--blue hidden__sm hidden__md hidden__lg">
            <template v-if="firstResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">«</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><button class="pagination__link btn--fake-link" rel="prev" @click="emitPageChange(currentPage - 1)">«</button></li>
            </template>
            <template v-for="link in linksMobile">
                <li class="pagination__li" :key="link.i" v-if="link.current"><span class="pagination__link" :class="{'pagination__link--active': true, }">{{ link.label }}</span></li>
                <li class="pagination__li pagination__li--disabled" :key="link.i" v-else-if="link.label == '...'"><span class="pagination__link">...</span></li>
                <li class="pagination__li" :key="link.i" v-else><button class="pagination__link btn--fake-link" @click="emitPageChange(link.i)">{{ link.label }}</button></li>
            </template>
            <template v-if="lastResult">
                <li class="pagination__li pagination__li--disabled"><span class="pagination__link">»</span></li>
            </template>
            <template v-else>
                <li class="pagination__li"><button class="pagination__link btn--fake-link" rel="next" @click="emitPageChange(currentPage + 1)">»</button></li>
            </template>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        pages: {
            type: Object,
            required: true,
        },
    },
    computed: {
        havePages() {
            if (this.pages.length == 0) {
                return false;
            }
            if (this.pages.last_page == 1) {
                return false;
            }
            return true;
        },
        currentPage() {
            return this.pages.current_page;
        },
        firstResult() {
            return (this.pages.current_page == 1) ? true : false;
        },
        lastResult() {
            return (this.pages.current_page >= this.pages.last_page) ? true : false;
        },
        links() {
            let links = [];
            if (!this.havePages) {
                return links;
            }

            let distanceFromFirst = false;
            let distanceFromCurrent = false;
            let distanceFromLast = false;
            for (let index = 1; index <= this.pages.last_page; index++) {
                // Work out distance from each node (first page, current page and last page)
                distanceFromFirst = index - 1;
                distanceFromLast = this.pages.last_page - index;
                distanceFromCurrent = Math.abs(this.pages.current_page - index);
                if (distanceFromFirst == 0 || distanceFromLast == 0 || distanceFromCurrent <= 3) {
                    // Check if there's a jump in index, and add a ... if there is
                    let linksLength = links.length;
                    if (linksLength > 0 && links[linksLength -1] !== '...' && index - links[linksLength -1].label > 1) {
                        links.push({
                            i: index + 's',
                            label: '...',
                            current: false,
                        });
                    }
                    links.push({
                        i: index,
                        label: index,
                        displayDesktop: true,
                        current: (index == this.pages.current_page) ? true : false,
                    });
                }
            }
            return links;
        },
        linksMobile() {
            let links = [];
            if (!this.havePages) {
                return links;
            }

            let distanceFromFirst = false;
            let distanceFromCurrent = false;
            let distanceFromLast = false;
            for (let index = 1; index <= this.pages.last_page; index++) {
                // Work out distance from each node (first page, current page and last page)
                distanceFromFirst = index - 1;
                distanceFromLast = this.pages.last_page - index;
                distanceFromCurrent = Math.abs(this.pages.current_page - index);
                if (distanceFromFirst == 0 || distanceFromLast == 0 || distanceFromCurrent <= 1) {
                    // Check if there's a jump in index, and add a ... if there is
                    let linksLength = links.length;
                    if (linksLength > 0 && links[linksLength -1] !== '...' && index - links[linksLength -1].label > 1) {
                        links.push({
                            i: index + 's',
                            label: '...',
                            current: false,
                        });
                    }
                    links.push({
                        i: index,
                        label: index,
                        displayDesktop: true,
                        current: (index == this.pages.current_page) ? true : false,
                    });
                }
            }
            return links;
        }
    },
    methods: {
        emitPageChange(page) {
            this.$emit('change-page', page);
        }
    }
}
</script>

<style lang="scss">
    button.pagination__link {
        background: white !important;
        // color: black;
        // border-top: 1px solid black;
        // border-bottom: 1px solid black;
        // .pagination--blue & {
        //     border-top: 1px solid #0293d6;
        //     border-bottom: 1px solid #0293d6;
        //     color: #0293d6;
        // }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/careers/components/CareersResultsPaging.vue